import { Typography, useTheme } from "@mui/material";
import { observer } from "mobx-react";
import moment from "moment";
import React, { FunctionComponent } from "react";
import ConfirmationDialog from "../../../../UI/AcxConfirmationDialog";
import { ConfigurationStepStore } from "../../AudioFileSamplerV2/Stores/ConfigurationStepStore";
interface OwnProps {
    store: ConfigurationStepStore;
}

type Props = OwnProps;

const DeleteRuleSetDialog: FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<Props>>> = observer((props) => {
    const theme = useTheme();
    return (
        <ConfirmationDialog
            isOpen={props.store.deleteRuleSetOpen}
            onClose={() => (props.store.deleteRuleSetOpen = false)}
            title={`Delete RuleSet`}
            content={
                <Typography
                    sx={{
                        color: theme.palette.text.secondary,
                        "& span": {
                            color: theme.palette.info.main,
                        },
                    }}
                    component={"div"}
                >
                    Are you sure that you would like to delete RuleSet{" "}
                    <span
                        style={{
                            fontWeight: "bold",
                            fontSize: "1.2em",
                        }}
                    >
                        {props.store.activeRuleSet?.name}
                    </span>{" "}
                    ?<br />
                    <>
                        <p
                            style={{
                                fontWeight: "bold",
                                color: theme.palette.text.primary,
                                fontSize: "1.2em",
                                marginBottom: "4px",
                            }}
                        >
                            Details:
                        </p>
                        <span
                            style={{
                                fontWeight: "bold",
                                color: theme.palette.text.primary,
                                marginRight: "8px",
                            }}
                        >
                            Created:
                        </span>{" "}
                        {props.store.activeRuleSet?.createdBy}{" "}
                        {moment(props.store.activeRuleSet?.createdOn).format(
                            "L",
                        )}
                        <br />
                    </>
                </Typography>
            }
            onConfirm={props.store.deleteRuleSet}
            buttonsDisabled={props.store.getTaskLoading("Delete RuleSet")}
        />
    );
});

export default DeleteRuleSetDialog;
